import {
    archiveUsers,
    deleteUsers,
    getUsers,
    blockUsers,
    getUser,
    unlockUsers,
    restoreUsers,
    getOfficialUserData,
    getDepartments,
    getDepartmentsWithGroupId,
    getDepartmentsWithOfficials,
    updateUserData,
    createUser,
} from '@/service/admin-service';
import { reactive } from 'vue';

const usersState = reactive({
    userId: null,
    usersList: [],
    userData: {},
    userOfficialId: null,
    officialUserData: {},
    formRef: null,
    lockFormRef: null,
    lockReasons: null,
    departmentsList: [],
    departmentsWithOfficialsList: [],
});

import usersLocalStore from '@/views/administration/users/store';

const { USER_STATUS } = usersLocalStore;

const setFormRef = value => {
    usersState.formRef = value;
};

const setLockFormRef = value => {
    usersState.lockFormRef = value;
};

const setUserIds = data => {
    usersState.userId = data;
};

const setOfficialUserIds = data => {
    usersState.userOfficialId = data;
};

const fetchUserData = async () => {
    const user = await getUser(usersState.userId);
    if (user) {
        usersState.userData = user;
    }
    return user;
};

const fetchOfficialUserData = async () => {
    const official = await getOfficialUserData(usersState.userOfficialId);
    if (official) {
        usersState.officialUserData = official;
    }
    return official;
};

const getUsersList = async () => {
    const items = await getUsers();
    if (items) {
        usersState.usersList = items;
    }
    return true;
};

const archiveUser = async userId => {
    const response = await archiveUsers(userId);
    getUsersList();
    return response;
};

const restoreUser = async userId => {
    const response = await restoreUsers(userId);
    getUsersList();
    return response;
};

const deleteUser = async userId => {
    const response = await deleteUsers(userId);
    getUsersList();
    return response;
};

const blockUser = async ({ userIds, from, to, lock_reason }) => {
    const response = await blockUsers(userIds, from, to, lock_reason);
    getUsersList();
    return response;
};

const unlockUser = async ({ userIds, from, to, lock_reason }) => {
    const response = await unlockUsers(userIds, from, to, lock_reason);
    getUsersList();
    return response;
};

const getDepartmentsList = async () => {
    const items = await getDepartments();
    if (items) {
        usersState.departmentsList = items;
    }
    return true;
};

const getDepartmentsListWithGroupId = async group_id => {
    const items = await getDepartmentsWithGroupId(group_id);
    if (items) {
        usersState.departmentsList = items;
    }
    return true;
};

const getDepartmentsWithOfficialsList = async kod_ecls => {
    const items = await getDepartmentsWithOfficials(kod_ecls);
    if (items) {
        usersState.departmentsWithOfficialsList = items;
    }
    return true;
};

const updateUser = async requestBody => {
    const response = await updateUserData(requestBody);
    getUsersList();
    return response;
};

const createUserData = async requestBody => {
    const response = await createUser(requestBody);
    getUsersList();
    return response;
};

const filteredUsersList = selectedValues => {
    const filteredUsersList =
        selectedValues && selectedValues.length > 0
            ? usersState.usersList?.filter(
                user =>
                    (selectedValues.includes(USER_STATUS.ACTIVE) && user.status === USER_STATUS.ACTIVE) ||
                    (selectedValues.includes(USER_STATUS.DELETED) && user.status === USER_STATUS.DELETED) ||
                    (selectedValues.includes(USER_STATUS.BLOCKED) && user.status === USER_STATUS.BLOCKED) ||
                    (selectedValues.includes(USER_STATUS.EXPIRED) && user.status === USER_STATUS.EXPIRED),
            )
            : usersState.usersList.filter(user => user.status === USER_STATUS.ACTIVE);
    return filteredUsersList;
};

export default {
    usersState,
    setFormRef,
    setLockFormRef,
    setUserIds,
    setOfficialUserIds,
    fetchUserData,
    fetchOfficialUserData,
    getUsersList,
    archiveUser,
    restoreUser,
    deleteUser,
    blockUser,
    unlockUser,
    getDepartmentsList,
    getDepartmentsListWithGroupId,
    getDepartmentsWithOfficialsList,
    updateUser,
    createUserData,
    filteredUsersList,
};
